import type { SerializableRecord } from '../model';
import { transformContentfulSys } from './transformContentfulSys';
import { isSerializableRecord } from './isSerializableRecord';

export function transformCircularContentfulReference(
  value: SerializableRecord
): SerializableRecord {
  const sys = transformContentfulSys(value.sys);
  const fields = isSerializableRecord(value.fields) ? value.fields : undefined;

  return {
    sys,
    fields: fields
      ? {
          slug: fields.slug,
          id: fields.id,
          title: fields.title,
          linkText: fields.linkText,
          linkTarget: fields.linkTarget,
          externalUrl: fields.externalUrl
        }
      : undefined
  };
}
